Array.prototype.remove = function (element) {
  var index = this.indexOf(element);

  if (index !== -1) {
    this.splice(index, 1);
    return true;
  }

  return false;
};

Array.prototype.prepend = function (element) {
  this.unshift(element);
};

Array.prototype.clear = function () {
  this.length = 0;
};

Array.prototype.first = function () {
  return this[0];
};

Array.prototype.last = function () {
  return this[this.length - 1];
};